import { render } from "./GarantiaAluguel.vue?vue&type=template&id=1ce5bdde&scoped=true"
import script from "./GarantiaAluguel.vue?vue&type=script&lang=js"
export * from "./GarantiaAluguel.vue?vue&type=script&lang=js"

import "./GarantiaAluguel.vue?vue&type=style&index=0&id=1ce5bdde&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce5bdde"]])

export default __exports__